module.exports = __webpack_public_path__ + "img/低通50.f5545a84.png";